/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 *
 * Vietnamese (Vietnam): vi-vn
 */

/**
 * Translation file for vi-VN locale
 *
 * @file vi.js
 * @author Mohamed yasar arabath M
 */

const vi = {
  'popularChannelSlider.allChannels': 'Tất cả các kênh',
  'popularChannelSlider.recommended': 'Được đề xuất',
  'hero.myetextbook.link': 'thư viện',
  'hero.myetextbook.text': 'Tựa đề không phù hợp? Truy cập sách giáo khoa điện tử của bạn',
  'hero.etextfeaturestitle': 'Tìm tài liệu học trong sách giáo khoa điện tử',
  'hero.etextfeaturesdescription': 'Sách giáo khoa điện tử của bạn đi kèm với tài liệu học được thiết kế để giúp bạn thành công. Học với thẻ ghi nhớ và nhiều công cụ khác ngay trong sách giáo khoa điện tử của bạn.',
  'aichat.title1': 'Nhận trợ giúp dựa trên AI cho mọi nội dung liên quan đến sách giáo khoa điện tử này.',
  'aichat.chatDesc1': 'Nhập câu hỏi để bắt đầu',
  'subscriptiontext.isSubscribed': 'Một phần trong gói đăng ký của bạn',
  'subscriptiontext.nonSubscriber': 'Nâng cấp để có quyền truy cập đầy đủ',
  'topicConatiner.otherHeader': 'Các video và bài tập liên quan',
  'topicConatiner.exactLiteHeader': 'Các khái niệm và bài tập liên quan',
  'moremenu.downloadApp': 'Tải ứng dụng',
  'moremenu.downloadAppAlreadyDownload': '%Click here% để tải ứng dụng về thiết bị khác và tự động đăng nhập hoặc sử dụng mã QR riêng để đăng nhập an toàn vào ứng dụng bạn đã cài đặt.',
  'moremenu.downloadAppNotDownload': '%Click here% để tải ứng dụng và đăng nhập an toàn bằng mã QR riêng',
  'channel.noBundletitle': 'Sử dụng Luyện thi cho các khóa học liên quan và các khóa học khác của bạn',
  'onboard.studyPlan': 'Đã tạo kế hoạch học tùy chỉnh!',
  'onboard.addCourseAnother': 'Bạn có muốn thêm khóa học khác không?',
  'onboard.purchase': 'Tôi cần mua sách giáo khoa điện tử của Pearson',
  'onboard.addCourseWithoutEtext': 'Thêm khóa học bằng Luyện thi',
  'onboard.mayBeLater': 'Để sau',
  'onboard.aboutCourse': 'Hãy cho chúng tôi biết về khóa học của bạn',
  'onboard.close': 'Đóng',
  'course.addTitle': 'Thêm khóa học',
  'common.PURCHASE': 'Mua hàng',
  'common.CLOSE': 'Đóng',
  'open': 'mở',
  'continue': 'Tiếp tục',
  'yes': 'Có',
  'no': 'Không',
  'audio': 'Âm thanh',
  'courses.toc.PUBLISH_SUCCESS': 'Thành công!',
  'courses.toc.PUBLISH_MESSAGE': 'Học sinh sẽ thấy những thay đổi của bạn vào lần tiếp theo họ mở nội dung.',
  'errors.GENERIC_TITLE': 'Bạn hiện không có quyền truy cập',
  'errors.GENERIC_DESC': 'Trước tiên, hãy tải lại trang hoặc xóa bộ nhớ cache. Nếu vẫn không hiệu quả, hãy liên hệ với bộ phận hỗ trợ của ',
  'errors.GENERIC_LINK': 'Pearson.',
  'errors.GENERIC_CODE': 'Mã lỗi: {code}',
  'errors.SUBSCRIPTION_GENERIC_TITLE': 'Không tìm thấy gói đăng ký',
  'errors.SUBSCRIPTION_GENERIC_DESC': 'Tài khoản của bạn không bao gồm quyền truy cập vào tựa sách này. Nếu bạn cho rằng mình đã nhận được thông báo này do nhầm lẫn, vui lòng liên hệ với bộ phận Hỗ trợ kỹ thuật của Pearson',
  'errors.SUBSCRIPTION_REGISTRATION_TITLE': 'Không tìm thấy gói đăng ký',
  'errors.SUBSCRIPTION_REGISTRATION_DESC': 'Gói đăng ký của bạn không bao gồm quyền truy cập sách giáo khoa điện tử. Tuy nhiên, bạn có thể đăng ký ngay bây giờ bằng thẻ tín dụng.',
  'link.ACCESSIBILITY': 'https://www.pearson.com/us/higher-education/products-services-teaching/course-content/textbooks-and-etexts/pearson-etext/accessibility.html',
  'link.PRIVACY': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonPrivacyPolicy.html',
  'link.SUPPORT': 'https://support.pearson.com/getsupport/s/',
  'link.TOSURL': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonEULA.html',
  'link.FAQS_NONMOJO': '',
  'link.TERMS_OF_USE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/terms-of-use.html',
  'link.PRIVACY_NOTICE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/privacy-policy.html',
  'link.ACCESSIBILITY_SUPPORT_NONMOJO': '',
  'menu.myAccount': 'Tài khoản của tôi',
  'menu.helpCenter': 'Trung tâm trợ giúp',
  'menu.preferencesCenter': 'Trung tâm tùy chỉnh',
  'menu.CONTACT_SUPPORT': 'Liên hệ bộ phận hỗ trợ',
  'menu.HELP_SUPPORT': 'Trợ giúp & hỗ trợ',
  'menu.FAQS': 'Câu hỏi thường gặp',
  'menu.CHAT_WITH_SUPPORT': 'Chat với bộ phận hỗ trợ',
  'menu.OTP_CODES': 'Mã OTP',
  'menu.LAUNCH_CODE': 'Mở nhật ký mã',
  'menu.SEND_CODE': 'Gửi mã mới cho người dùng qua email',
  'menu.SEND_CODE_PHONE': 'Gửi mã mới cho người dùng qua tin nhắn văn bản',
  'menu.LEGAL': 'Pháp lý',
  'menu.PRIVACY_NOTICE': 'Thông báo về quyền riêng tư',
  'menu.TITLE_INFO': 'Thông tin về tựa đề',
  'menu.PEARSON_ACCESSIBILITY': 'Hỗ trợ tiếp cận Pearson',
  'menu.DEVICE_WARNING_MESSAGE': 'Đăng ký {deviceLimit} thiết bị. Thay đổi 1 thiết bị mỗi tháng.',
  'menu.ACCESSIBILITY': 'Hỗ trợ tiếp cận',
  'menu.ACCESSIBILITY_SUPPORT': 'Hỗ trợ tiếp cận',
  'menu.DEVICES': 'Các thiết bị gần đây',
  'menu.THIS_DEVICE': 'Thiết bị này',
  'menu.GET_THE_APP_DOWNLOAD': 'Tải ứng dụng di động',
  'menu.MOJO_APP_INFO': 'Truy cập cửa hàng ứng dụng trên điện thoại hoặc máy tính bảng để sử dụng Pearson+ ngoại tuyến.',
  'menu.DEVICE_LABEL': 'Thiết bị',
  'menu.DEVICE_DISCONNECT': 'Ngắt kết nối',
  'menu.FOXIT': 'Hỗ trợ bởi FoxIT',
  'menu.TERMS_OF_USE': 'Điều khoản sử dụng',
  'menu.SIGN_OUT': 'Đăng xuất',
  'menu.PRINT_PAGE': 'In trang',
  'menu.COPY_RIGHT': 'Copyright © {year} Pearson Education Inc. All Rights Reserved.',
  'print.FOOTER_MESSAGE': 'Được in bởi {fullName}({email}) vào ngày {currentDate}.',
  'print.WATERMARK': 'Bản quyền © {year} Pearson Education',
  'device.SWAPPED_ALREADY': 'Bạn đã chuyển đổi trong tháng này rồi',
  'device.SWITCH_DEVICE': 'Chuyển sang thiết bị hiện tại?',
  'device.SWITCH_ONCE': 'Vì mỗi tháng chỉ có thể chuyển đổi một lần, bạn sẽ không thể hủy thao tác này.',
  'device.SEAT_TAKEN': 'Đã hết chỗ',
  'device.DISCONNECT_DEVICE': 'Bạn chỉ có thể đăng nhập trên tối đa 3 thiết bị. Để tiếp tục, vui lòng ngắt kết nối một thiết bị khác.',
  'device.ALERT_TEXT': 'Lưu ý, bạn chỉ có thể thay đổi thiết bị một lần mỗi tháng.',
  'device.DISCONNECT': 'Ngắt kết nối',
  'device.CONTINUE': 'Tiếp tục',
  'device.HEADER': 'Kết thúc phiên trình duyệt khác?',
  'device.CLOSE': 'Trở về trang chủ',
  'device.CODE': 'Tiếp tục tại đây bằng cách nhập mã xác thực chúng tôi đã gửi tới {maskedEmail}. Không hoạt động? Kiểm tra thư mục thư rác, {email}, hoặc liên hệ với {support}.',
  'device.TIMER': 'Bạn có {time} để nhập mã của mình tại đây',
  'device.RESEND': '{resend}',
  'device.FAQ': 'Câu hỏi thường gặp',
  'device.RESEND_NAME': 'Gửi lại',
  'device.NOTE': 'Nếu bạn thường xuyên dùng Pearson+ ở 2 nơi, chẳng hạn như ở nơi làm việc và ở nhà, hãy nhớ đăng xuất mỗi khi bạn dùng xong. Bạn cũng có thể dùng ứng dụng di động Pearson+ trên tối đa 2 thiết bị. Để biết thêm thông tin, hãy xem {faq}.',
  'device.NOTE_HEADER': 'Lần sau hãy tránh điều này nhé',
  'device.CONTACT_SUPPORT': 'hỗ trợ khách hàng',
  'device.CONTACT_EMAIL': 'cập nhật email của bạn',
  'device.INCORRECT': 'Không chính xác – hãy kiểm tra lại mã của bạn hoặc gửi lại.',
  'device.MANY_ATTEMPTS': 'Quá nhiều lần nhập sai, vui lòng gửi lại mã',
  'device.EXPIRED': 'Thời gian của bạn đã hết hạn, vui lòng gửi lại mã',
  'device.ACCESS_HEADER': 'Đăng nhập thành công!',
  'device.ACCESS_DESC': 'Phiên đăng nhập của bạn đã được xác thực. Bạn có muốn cập nhật mật khẩu lúc này không?',
  'device.ACCESS_CHANGE_PASSWORD': 'Đổi mật khẩu',
  'device.ACCESS_RESET_PASSWORD': 'Đặt lại mật khẩu',
  'device.THREATONE_TITLE': 'Mọi thứ ổn chứ?',
  'device.THREATONE_DESC': 'Chúng tôi phát hiện một số hoạt động nghi vấn trên tài khoản của bạn.',
  'device.THREATONE_DESC_TWO': 'Bạn nên thay đổi mật khẩu lúc này.',
  'device.MAY_BE_LATER': 'Để sau',
  'device.OKAY': 'Ok',
  'device.ACCOUNT_LOCK_DESC': 'Để đảm bảo an toàn, chúng tôi sẽ đăng xuất bạn. Chúng tôi đã gửi liên kết đặt lại mật khẩu đến email đăng ký tài khoản của bạn.',
  'device.ACCOUNT_LOCK_TITLE': 'Chúng tôi phát hiện một số hoạt động đáng ngờ trên tài khoản của bạn',
  'device.ACCOUNT_LOCK_TIMER': 'Bạn sẽ bị đăng xuất sau {time}',
  'navigation.PAGE': 'Trang',
  'launchcode.CREATEBY': 'Được tạo bởi:',
  'launchcode.sentvia': 'Được gửi qua:',
  'launchcode.CODEINLAST': 'Các mã trong 7 ngày qua:',
  'launchcode.TIMESENT': 'Thời gian gửi: ',
  'launchcode.ACCOUNTEMAIL': 'Email tài khoản:',
  'launchcode.LAUNCHDIALOGTITLE': 'Nhật ký mã OTP',
  'textmessage.TITLE': 'Nhập số điện thoại',
  'textmessage.PHONE_NUMBER': 'Số điện thoại',
  'textmessage.SEND_CODE': 'Gửi mã',
  'textmessage.INVALID_NUMBER': 'Số điện thoại không hợp lệ.',
  'textmessage.SUCCESS_MESSAGE': 'Mã đã được gửi',
  'remove.title': 'Xóa tựa sách?',
  'remove.subTitle': 'Bạn luôn có thể lấy lại sau này – chỉ cần sử dụng chức năng tìm kiếm để thêm lại.',
  'remove.buttonText': 'Xóa',
  'search.searchPlaceHolderPPlus': 'Tìm theo ISBN, Tựa đề hoặc Tác giả',
  'search.searchPlaceHolderEText': 'Tìm kiếm trong thư viện của bạn',
  'footer.downloadMobileApp': 'Tải ứng dụng di động',
  'footer.termsOfUse': 'Điều khoản sử dụng',
  'footer.privacy': 'Quyền riêng tư',
  'footer.cookies': 'Cookie',
  'footer.doNotSellMyPersonalInformation': 'Không bán thông tin cá nhân của tôi',
  'footer.accessibility': 'Hỗ trợ tiếp cận',
  'footer.patentNotice': 'Thông báo về bằng sáng chế',
  'footer.copyrights': 'Pearson Bảo lưu mọi quyền.',
  'hero.toc.defaultPlacehoder': '--- chọn một chủ đề ---',
  'hero.openEtextBookV1': 'Mở sách giáo khoa điện tử',
  'hero.heroHeading': 'Vì bạn đang học <span>{channel_title}</span>',
  'hero.heroHeadingForBundleUser': 'Luyện thi',
  'hero.study.help': 'Nhận hỗ trợ học',
  'hero.study.jumpBackIn': 'Tiếp tục lại ngay',
  'hero.study.numOfUsers': 'Hiện có <b>{num_of_users}</b> học sinh đang sử dụng kênh.',
  'hero.heroChannel.cardsHeading': 'Tiếp tục từ chỗ bạn đã dừng lại',
  'hero.marketingcard1.copy.title': 'Học qua video',
  'hero.marketingcard1.copy.description': 'Xem các video ngắn giải thích chi tiết các chủ đề phức tạp.',
  'hero.marketingcard2.copy.title': 'Bài tập thực hành',
  'hero.marketingcard2.copy.description': 'Chuẩn bị cho kỳ thi của bạn với hàng ngàn câu hỏi tương tự đề thi và video giải đáp.',
  'hero.marketingcard3.copy.title': 'Nhận sự trợ giúp từ người có kinh nghiệm',
  'hero.marketingcard3.copy.description': 'Đặt câu hỏi và nhận câu trả lời từ các chuyên gia trong lĩnh vực đó.',
  'hero.popularTopics.heading': 'Các chủ đề phổ biến khác trên kênh này',
  'hero.popularChannels.headingv1': 'Bạn đang tham gia khóa học khác?',
  'hero.popularChannels.descriptionv2': 'Tìm hiểu các chủ đề hỗ trợ học phổ biến.',
  'hero.practice': 'Luyện tập',
  'hero.herobook.mappedChannelHeading': 'Hỗ trợ học được đề xuất trong Kênh này',
  'libraryL2.myBooks': 'Sách của tôi',
  'libraryL2.archived': 'Đã lưu trữ',
  'libraryL2.back': 'Quay lại',
  'hero.practiceProblem': 'Bài tập thực hành',
  'nativeAppBanner.drawer.title': 'Mở trong ...',
  'nativeAppBanner.drawer.pearsonApp': 'Ứng dụng Pearson+',
  'nativeAppBanner.banner.title': 'Ứng dụng Pearson+',
  'nativeAppBanner.banner.description': 'Học mọi lúc, mọi nơi',
  'hero.promotionalcard.list1': 'Các video ngắn giúp đơn giản hóa các chủ đề phức tạp',
  'hero.promotionalcard.list2': 'Hàng ngàn câu hỏi giống như bài thi',
  'hero.promotionalcard.list3': 'Nhận câu trả lời từ các chuyên gia',
  'hero.studyandexamprep': 'Luyện thi',
  'hero.heroBook.sectionSubHeadingV1': 'Phân tích các chủ đề khó bằng các video giải thích khái niệm và câu hỏi luyện tập được thiết kế riêng cho khóa học của bạn.',
  'hero.heroBook.sectionSubHeadingV2': 'Phân tích các chủ đề khó bằng các bài giải thích khái niệm và câu hỏi luyện tập được thiết kế riêng cho khóa học của bạn.',
  'hero.SeeAllStudyOptions': 'Xem tất cả các lựa chọn học tập',
  'hero.herobook.mappedChannelHeadingV1': 'Video đề xuất và câu hỏi luyện tập',
  'hero.popularTopics.headingV1': 'Các chủ đề phổ biến khác',
  'hero.heroHeadingV1': 'Dành cho <span>{replace_value}</span>',
  'hero.learnmore': 'Tìm hiểu thêm',
  'hero.eTextbook': 'Sách giáo khoa điện tử',
  'hero.goToPage.label': 'Truy cập trang',
  'subscription.studyTitle': 'Luyện thi',
  'print.printAvailTitle': 'Bạn muốn in trang này? Cách thực hiện',
  'print.printAvailDesc': 'Trong sách giáo khoa điện tử của bạn, chọn biểu tượng tài khoản ở góc trên bên phải. Từ danh sách tùy chọn, hãy chọn “In trang” rồi chọn cài đặt in.',
  'print.printNotAvailTitle': 'Tính năng in cho sách điện tử này chưa được kích hoạt.',
  'print.printNotAvailDesc': 'Để truy cập ngoại tuyến thuận tiện, hãy tải tựa đề của bạn thông qua ứng dụng di động Pearson+ và tận dụng sự linh hoạt khi học tập mọi lúc, mọi nơi!',
  'hero.header.cta': 'Truy cập công cụ học tập',
  'hero.header.ctav2': 'Mở Luyện thi',
  'hero.marketing.title': 'Tìm sách giáo khoa điện tử của bạn',
  'hero.marketing.subTitle': 'Chọn từ hơn 2.000 sách giáo khoa điện tử có kèm âm thanh, thẻ ghi nhớ, ghi chú và nhiều tính năng khác. Chỉ $10,99/tháng cho kỳ 4 tháng.',
  'hero.popularchannels.desc': 'Nhận hỗ trợ học tập hàng đầu này',
  'hero.removecourse.title': 'Xóa khóa học khỏi bảng điều khiển?',
  'hero.removecourse.description': 'Bạn luôn có thể thêm lại khóa học này vào bảng điều khiển bằng cách nhấp vào “Thêm khóa học”',
  'hero.removecourse.primaryCtaText': 'Xóa',
  'hero.removecourse.secondaryCtaText': 'Hủy',
  'hero.tableOfContents': 'Mục lục',
  'hero.search': 'Tìm kiếm',
  'hero.emptystate.cta': 'Tìm kiếm sách giáo khoa điện tử',
  'hero.watch_it_again': 'Xem lại lần nữa',
  'hero.mondly.learnLang.title': 'Học một ngôn ngữ mới miễn phí',
  'hero.mondly.subTitle': 'Người dùng sách giáo khoa điện tử của Pearson được tặng ba tháng sử dụng Mondly của Pearson miễn phí.',
  'hero.mondly.description': 'Hầu hết các ứng dụng học ngôn ngữ chỉ hỗ trợ học qua tiếng Anh. Nhưng học hiệu quả nhất là thông qua tiếng mẹ đẻ, vì vậy, Mondly giúp bạn học bằng bất kỳ ngôn ngữ nào trong số <strong>41 ngôn ngữ</strong> chúng tôi hỗ trợ.',
  'hero.mondly.startLearningCTA': 'Bắt đầu học',
  'hero.mondly.marketing.bestApp': 'Ứng dụng hay nhất',
  'hero.mondly.marketing.appStore': 'App Store',
  'hero.mondly.marketing.appYear': 'Ứng dụng của năm',
  'hero.mondly.marketing.fbStart': 'Giải thưởng Facebook FbStart - 2017 EMEA Winner',
  'hero.mondly.marketing.editorChoice': 'Lựa chọn Trình chỉnh sửa',
  'hero.mondly.marketing.googlePlay': 'Google Play',
  'header.menu.learnLanguage': 'Học một ngôn ngữ',
  'header.menu.moreAtPearson': 'Khám phá thêm tại Pearson',
  'hero.subscriptionStatusTitle2': 'Tài nguyên của bạn trên Pearson+',
  'hero.startStudying': 'Bắt đầu học',
  'onboard.studyMaterials': 'Chọn môn học của bạn và chúng tôi sẽ tạo bảng điều khiển với tài liệu học được cá nhân hóa.',
  'hero.myETextbooks': 'Sách giáo khoa điện tử của tôi',
  'header.continueInTheApp': 'Tiếp tục trên ứng dụng',
  'hero.learnTxt': 'Học',
  'hero.examPrepTxt': 'Chuẩn bị cho kỳ thi',
  'hero.aITutorTxt': 'Gia sư AI',
  'AI.toolTip': 'Hỏi tôi bất cứ điều gì trong sách giáo khoa điện tử của bạn',
  'hero.studyExamPrepAllYourCourses': 'Luyện thi cho tất cả các khóa học của bạn',
  'header.qrCode.subHeaderTxt': 'Sử dụng mã QR này để đăng nhập nhanh chóng và an toàn vào ứng dụng Pearson+ trên thiết bị di động.',
  'header.qrCode.dontHaveApp': 'Bạn chưa có ứng dụng?',
  'header.qrCode.footerTxt': 'Quét mã này để truy cập App Store hoặc Google Play. Sau khi tải ứng dụng xuống, hãy quét mã này lần nữa để đăng nhập.',
  'header.qrCode.errorMsg': 'Không tải được mã QR. Đóng và thử lại.',
  'hero.yourETextbook': 'Sách giáo khoa điện tử của bạn',
  'onboard.addCourseWithEtextBundle': 'Thêm khóa học bằng Luyện thi',
  'onboard.disableTooltipText': 'Đã thêm tất cả các khóa học Luyện thi!',
  'subscriptionstatus.bundlecta': 'Truy cập Luyện thi',
  'subscriptionstatus.nonbundlecta': 'Truy cập Luyện thi',
  'channel.genericBundle': 'Sử dụng Luyện thi để được hỗ trợ trong các môn học khác',
  'channel.relatedBundle': 'Sử dụng Luyện thi để được hỗ trợ trong các môn học khác nữa',
  'onboard.courseAdded': 'Đã thêm khóa học!',
  'hero.flashcards': 'Thẻ ghi nhớ',
  'relatedChannelCard.title': 'Nâng cao khả năng học của bạn với tài nguyên liên quan này',
  'relatedChannelCard.badgeText': 'Luyện thi liên quan',
  'sessionInactivity.title': 'Bạn vẫn đang ở đó chứ?',
  'sessionInactivity.description': 'Phiên đăng nhập của bạn sẽ hết hạn sau <b>%TIMER%</b> do không hoạt động.<br/>Bạn có muốn duy trì trạng thái đăng nhập không?',
  'sessionInactivity.keepMeSignIn': 'Duy trì đăng nhập',
  'sessionInactivity.signOut': 'Đăng xuất',
  'sessionTimeout.title': 'Phiên đăng nhập đã hết hạn',
  'sessionTimeout.description': 'Phiên đăng nhập của bạn đã hết hạn do không hoạt động.',
  'print.qrCode.header': 'Sử dụng mã QR này để mở ứng dụng Pearson+ trên thiết bị di động của bạn.',
  'print.qrCode.footer': 'Quét mã này để truy cập App Store hoặc Google Play. Sau khi cài đặt ứng dụng, hãy đăng nhập để tải xuống và truy cập tựa đề của bạn.',
  'hero.nestest.title': 'Chuẩn bị cho kỳ thi cấp chứng chỉ giáo viên',
  'hero.nestest.subTitle': 'Người dùng Pearson+ giờ đây có thể truy cập các khóa luyện thi và bài kiểm tra thử được biên soạn theo chuẩn quốc gia để chuẩn bị cho kỳ thi chứng chỉ giáo viên.',
  'hero.channelAI.title': 'Bạn cần trợ giúp? Gia sư AI sẽ giúp bạn.',
  'hero.channelAI.desc': 'Đặt câu hỏi và nhận hướng dẫn làm bài tập về nhà từng bước, gợi ý học tập cùng nhiều tính năng khác – sự hỗ trợ được cá nhân hóa mọi lúc bạn cần.',
  'hero.channelAI.action': 'Hãy hỏi gia sư AI ngay',
  'new': 'Mới!',
  'hero.practice.numOfUsers': 'Phần này có <b>{practice_num_of_users}</b> bài tập thực hành.',
  'hero.practice.cta': 'Luyện tập ngay bây giờ',
  'hero.practice.title': 'Bài tập thực hành',
  'diagnostics.errorMsg': 'Chẩn đoán không tải được. Đóng và thử lại',
  'qrcode.title': 'Bắt đầu học tập ở bất cứ đâu',
  'qrcode.subtitle': 'Học mọi lúc, mọi nơi với ứng dụng di động Pearson+. Tải xuống ngay để trải nghiệm học tập liền mạch.',
  'qrcode.detailsv1': 'Với ứng dụng Pearson+, bạn có thể dùng mã QR này để tiếp tục từ chỗ bạn đã dừng lại. Tìm kiếm sách, học bằng thẻ ghi nhớ, xem video bài giảng và nhiều tiện ích khác ở bất cứ đâu.',
  'qrcode.detailsv2': 'Quét mã QR này bất cứ khi nào bạn muốn đăng nhập nhanh và tiếp tục học từ nơi bạn đã dừng lại.',
  'qrcode.details': 'Với ứng dụng Pearson+, bạn có thể dùng mã QR này để tiếp tục từ chỗ bạn đã dừng lại.',
  'qrcode.appstore': 'App Store',
  'qrcode.playstore': 'Google Play',
  'nativePromoBanner.description': 'Học mọi lúc, mọi nơi với ứng dụng di động Pearson+. Tải xuống ngay để trải nghiệm học tập liền mạch.',
  'install': 'Install',
  'header.menu.createCourse': 'Khóa học mới',
  'header.dropdown.courses': 'Khóa học',
  'header.dropdown.recentlyViewed': 'Đã xem gần đây',
  'header.dropdown.viewAll': 'Xem tất cả các khóa học',
  'aet.courseHeader.inviteStudents': 'Mời học sinh',
  'aet.courseHeader.inviteStudentModal.subTitle': 'Mời học sinh truy cập sách giáo khoa điện tử này bằng cách sao chép địa chỉ liên kết hoặc hướng dẫn bên dưới vào email hoặc đề cương của bạn.',
  'aet.courseHeader.inviteStudentModal.linkAddress': 'Địa chỉ liên kết',
  'aet.courseHeader.inviteStudentModal.copyLink': 'Sao chép liên kết',
  'aet.courseHeader.inviteStudentModal.instructionsTitle': 'Hướng dẫn kèm địa chỉ liên kết',
  'aet.courseHeader.inviteStudentModal.copyInstructions': 'Sao chép hướng dẫn',
  'aet.courseHeader.inviteStudentModal.instructionIntro': 'It\'s time to access {bookTitle} the eTextbook for {courseName}.\n\n',
  'aet.courseHeader.inviteStudentModal.instructionAccessLink': 'When you\'re ready, access your eTextbook at: {enrollmentLink}\n\n',
  'aet.courseHeader.inviteStudentModal.instructionSignIn': 'Bạn sẽ được yêu cầu đăng nhập bằng tài khoản Pearson hiện có của mình. Nếu chưa có tài khoản Pearson, bạn có thể tạo một tài khoản.  ',
  'aet.courseHeader.inviteStudentModal.instructionHelp': 'Need help? ',
  'aet.courseHeader.inviteStudentModal.instructionHelpLink': 'AskPearson',
  'aet.courseHeader.startDate': 'Ngày bắt đầu:',
  'aet.courseHeader.endDate': 'Ngày kết thúc:',
  'aet.courseHeader.entitlement': 'Entitlement:',
  'aet.courseHeader.format': 'Định dạng:',
  'aet.home.manageroster': 'Quản lý danh sách học sinh',
  'aet.home.managegradesync': 'Quản lý đồng bộ điểm',
  'aet.home.copycourse': 'Sao chép khóa học',
  'aet.home.unlinkcourse': 'Unlink course',
  'aet.instructorCourse.tabs.current': 'Hiện tại',
  'aet.instructorCourse.tabs.past': 'Đã qua',
  'aet.instructorCourse.tabs.courseSettings': 'Cài đặt khóa học',
  'aet.instructorCourse.tabs.manageRoster': 'Quản lý danh sách học sinh',
  'aet.instructorCourse.currentCourses.title': 'Các khóa học hiện tại',
  'aet.instructorCourse.pastCourses.title': 'Các khóa học trước đây',
  'aet.instructorCourse.createOrCopy.title': 'Tạo hoặc sao chép khóa học',
  'aet.instructorCourse.createOrCopy.sectionTitle': 'Sao chép khóa học của giảng viên khác hoặc tạo khóa học mới',
  'aet.instructorCourse.createOrCopy.copyPanel.title': 'Sao chép khóa học của giảng viên khác',
  'aet.instructorCourse.createOrCopy.copyPanel.subtitle': 'Nhập ID khóa học để tìm khóa học bạn muốn sao chép.',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdLabel': 'ID khóa học',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdPlaceholder': 'Nhập ID khóa học',
  'aet.instructorCourse.createOrCopy.copyPanel.searchedForPrefix': 'Bạn đã tìm kiếm',
  'aet.instructorCourse.createOrCopy.catalogPanel.title': 'Tạo khóa học mới từ danh mục',
  'aet.instructorCourse.createOrCopy.catalogPanel.subtitle': 'Tìm kiếm theo tựa đề, tác giả, mã ISBN hoặc từ khóa môn học.',
  'aet.instructorCourse.createOrCopy.catalogPanel.searchPlaceholder': 'Tìm kiếm...',
  'aet.instructorCourse.createOrCopy.showMoreLabel': 'Hiện thêm',
  'aet.instructorCourse.createOrCopy.showLessLabel': 'Ẩn bớt',
  'aet.instructorCourse.cancel': 'Hủy',
  'aet.instructorCourse.loading': 'Đang tải...',
  'aet.instructorCourse.courseForm.copyError': 'Your course cannot be copied because the title is no longer supported. Please contact your Pearson representative or customer support.',
  'aet.instructorCourse.courseForm.gradeSync': 'Đồng bộ điểm',
  'aet.instructorCourse.courseForm.gradeSyncLinkLabel': 'Quản lý đồng bộ điểm',
  'aet.instructorCourse.courseForm.courseNameLabel': 'Tên khóa học',
  'aet.instructorCourse.courseForm.courseNamePlaceholder': 'Không có tựa đề',
  'aet.instructorCourse.courseForm.sectionNameLabel': 'Tên học phần',
  'aet.instructorCourse.courseForm.sectionNamePlaceholder': 'Không có tựa đề',
  'aet.instructorCourse.courseForm.institutionFieldLabel': 'Cơ sở đào tạo',
  'aet.instructorCourse.courseForm.institutionSelectLabel': 'Select an Institution',
  'aet.instructorCourse.courseForm.institutionPlaceholder': 'Start typing your institution',
  'aet.instructorCourse.courseForm.institutionRequiredError': 'Yêu cầu nhập cơ sở đào tạo',
  'aet.instructorCourse.courseForm.institutionSearchError': 'Đã xảy ra lỗi. Vui lòng thử lại.',
  'aet.instructorCourse.courseForm.institutionNoResults': 'Không tìm thấy kết quả nào',
  'aet.instructorCourse.courseForm.findAnotherInstitutionLabel': 'Find another Institution',
  'aet.instructorCourse.courseForm.startDateLabel': 'Ngày bắt đầu khóa học',
  'aet.instructorCourse.courseForm.endDateLabel': 'Ngày kết thúc khóa học',
  'aet.instructorCourse.courseForm.datePlaceholder': 'dd/mm/yy (ngày/tháng/năm)',
  'aet.instructorCourse.courseForm.allowCopyLabel': 'Cho phép người khác sao chép khóa học này',
  'aet.instructorCourse.courseForm.shareCodeLabel': 'Chia sẻ mã này với các giảng viên muốn sao chép khóa học này',
  'aet.instructorCourse.courseForm.copyCodeLabel': 'Sao chép mã',
  'aet.instructorCourse.courseForm.optionalSuffix': '(không bắt buộc)',
  'aet.instructorCourse.courseForm.formValidationLiveRegion': 'Biểu mẫu có lỗi xác thực',
  'aet.instructorCourse.courseForm.submitContinue': 'Tiếp tục',
  'aet.instructorCourse.courseForm.submitContinueLoading': 'Đang lưu...',
  'aet.instructorCourse.courseForm.submitError': 'Không thể tạo khóa học cho bạn. Vui lòng thử lại.',
  'aet.instructorCourse.courseForm.submitEditError': 'Không thể lưu các thay đổi của bạn. Vui lòng thử lại.',
  'aet.instructorCourse.courseForm.submitSaveChanges': 'Lưu thay đổi',
  'aet.instructorCourse.courseForm.materialsHeader': 'Tài liệu khóa học',
  'aet.instructorCourse.courseForm.resolveError': 'Không thể tải tài liệu khóa học. Vui lòng thử lại.',
  'aet.instructorCourse.courseForm.copySourceError': 'We could not load the course to copy. Please search again from Create or copy course.',
  'aet.instructorCourse.coursesSort.lastViewed': 'Lần xem gần nhất',
  'aet.instructorCourse.coursesSort.recentlyAdded': 'Vừa thêm gần đây',
  'aet.instructorCourse.coursesSort.aToZ': 'Từ A đến Z',
  'aet.instructorCourse.coursesSort.zToA': 'Từ Z đến A',
  'aet.instructorCourse.manageRoster.column.name': 'Tên',
  'aet.instructorCourse.manageRoster.column.role': 'Vai trò',
  'aet.instructorCourse.manageRoster.column.email': 'Email',
  'aet.instructorCourse.manageRoster.column.status': 'Trạng thái',
  'aet.instructorCourse.manageRoster.enrolledDate': 'Enrolled {date}',
  'aet.instructorCourse.manageRoster.notAvailable': '--',
  'aet.instructorCourse.roster.role.student': 'Học sinh',
  'aet.instructorCourse.roster.role.ta': 'Trợ lý giáo viên',
  'aet.instructorCourse.roster.role.instructor': 'Người hướng dẫn',
  'aet.instructorCourse.roster.status.active': 'Hoạt động',
  'aet.instructorCourse.roster.status.inactive': 'Không hoạt động',
  'aet.instructorCourse.manageRoster.filter.allMembers': 'Tất cả thành viên',
  'aet.instructorCourse.manageRoster.filter.activeStudents': 'Học sinh đang học',
  'aet.instructorCourse.manageRoster.filter.inactiveStudents': 'Học sinh tạm dừng',
  'aet.instructorCourse.manageRoster.filter.teachingAssistant': 'Trợ giảng',
  'aet.instructorCourse.manageRoster.filter.instructor': 'Người hướng dẫn',
  'aet.instructorCourse.courseForm.materialsAuthorLabel': 'Tác giả:',
  'aet.instructorCourse.courseForm.materialsIsbnLabel': 'ISBN:',
  'aet.instructorCourse.courseForm.materialsCreationDateLabel': 'Ngày tạo khóa học:',
  'aet.instructorCourse.noCoursesFound': 'Không tìm thấy khóa học nào',
  'aet.instructorCourse.backButton': 'Quay lại',
  'aet.instructorCourse.selectCourse': 'Chọn khóa học',
  'aet.home.linkedToLms': 'Đã kết nối với Hệ thống quản lý học tập (LMS)',
  'aet.instructorCourse.courseForm.title.create': 'Tạo khóa học',
  'aet.instructorCourse.courseForm.title.copy': 'Sao chép khóa học',
  'aet.instructorCourse.courseForm.title.edit': 'Thông tin khóa học',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.title': 'Bài tập',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.content': 'Nội dung bài tập',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.dueDates': 'Hạn nộp bài tập',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.title': 'Phần đánh dấu và ghi chú',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.highlightColor': 'Màu đánh dấu',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.noteText': 'Nội dung ghi chú',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.sharedStatus': 'Trạng thái được chia sẻ',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.title': 'Danh sách học sinh và mức độ tương tác',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.studentNames': 'Tên học sinh',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.emailAddresses': 'Địa chỉ email',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.enrollments': 'Ghi danh',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.completionAndInsights': 'Hoàn thành và thông tin chi tiết',
  'aet.instructorCourse.courseForm.copiedContentAccordion.settings.title': 'Cài đặt',
  'aet.instructorCourse.courseForm.copiedContentAccordion.settings.aiToolEnablement': 'AI Tool enablement',
  'aet.instructorCourse.courseForm.copyAccordionTitle': 'Show what’s copied',
  'aet.instructorCourse.courseForm.copyAccordionSubTitle': 'Dữ liệu đã sao chép',
  'aet.studentRoster.manageStudentRosterButton': 'Quản lý danh sách học sinh',
  'aet.studentRoster.dontHaveAnyStudent': 'Looks like you don’t have any students.',
  'aet.assignments.exportStudentProgressButton': 'Xuất kết quả học tập của học sinh',
  'aet.home.student.roaster.enrolmentInformationTitle': 'Enrolment information',
  'aet.home.student.roaster.enrolmentInformation.status': 'Tình trạng:',
  'aet.home.student.roaster.enrolmentInformation.enrolled': 'Đã ghi danh:',
  'aet.home.student.roaster.enrolmentInformation.access': 'Access:',
  'aet.home.student.roaster.enrolmentInformation.role': 'Vai trò:',
  'aet.home.student.roaster.enrolmentInformation.promotionCardTitle': 'Promote  {studentName} ?',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent1': 'Với vai trò trợ giảng, người này sẽ có thể theo dõi sự tiến bộ và kết quả học tập của tất cả học sinh trong lớp này.',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent2': 'Họ cũng có thể quản lý học sinh và bài tập, tuy nhiên họ sẽ không thể xóa lớp học.',
  'aet.home.student.roaster.enrolmentInformation.promotionCardConfirmLabel': 'Nâng lên làm trợ giảng',
  'aet.home.manageRoster.searchPlaceholder': 'Tìm kiếm học sinh',
  'aet.home.manageRoster.inactivateButtonLabel': 'Chuyển sang trạng thái không hoạt động những học sinh đã chọn',
  'aet.home.manageRoster.FilterLabel': 'Hiện',
  'aet.home.manageRoster.updatingMessage': 'Đang cập nhật danh sách... Quá trình này có thể mất vài phút.',
  'aet.home.courses.search.searchPlaceHolder': 'Tìm kiếm các khóa học của bạn',
  'aet.courses.emptyStateDescription': 'Bắt đầu xây dựng khóa học của bạn bằng cách chọn một tùy chọn bên dưới.',
  'nativePromoBanner.continueInBrowser': 'Tiếp tục trên trình duyệt',
  'globalnav.tooltip.hideNavText': 'Ẩn thanh điều hướng',
  'globalnav.tooltip.showNavText': 'Hiện thanh điều hướng',
  'aet.syllabus.progressTitle': 'Đang trích xuất...',
  'aet.syllabus.progressDesc': 'Vui lòng chờ trong khi chúng tôi xử lý đề cương khóa học của bạn.',
  'aet.syllabus.uploadInputLabel': 'Kéo và thả tệp hoặc nhấp để tải lên',
  'aet.syllabus.uploadSyllabusTabLabel': 'Tải đề cương khóa học lên',
  'aet.syllabus.dateAdjusterTabLabel': 'Công cụ điều chỉnh ngày',
  'aet.syllabus.addManuallyTabLabel': 'Thêm theo cách thủ công',
  'aet.syllabus.addEditLaterText': 'Bạn luôn có thể thêm và sửa bài tập sau',
  'aet.syllabus.editAssignmentLabel': 'Sửa bài tập',
  'aet.syllabus.addAssignmentLabel': 'Thêm bài tập',
  'aet.syllabus.assignmentTitleLabel': 'Tiêu đề bài tập',
  'aet.syllabus.dueDateLabel': 'Hạn nộp',
  'aet.syllabus.editDueDateLabel': 'Chỉnh sửa hạn nộp',
  'aet.syllabus.chaptersCoveredLabel': 'Chọn các chương hoặc phần cần bao gồm.',
  'aet.syllabus.updateCtaLabel': 'Cập nhật bài tập',
  'aet.syllabus.addCtaLabel': 'Thêm bài tập',
  'aet.syllabus.uploadLabel': 'Tải lên',
  'aet.syllabus.confirmLabel': 'Xác nhận',
  'aet.syllabus.updateDatesLabel': 'Ngày cập nhật',
  'aet.syllabus.dateNormalization.yearAdjustedContentSingle': 'Your due date was updated. Review it, then publish.',
  'aet.syllabus.coverageDedupe.adjustedContent': 'Your chapter/section information was updated. Review it, then publish.',
  'aet.syllabus.unassignedCoverageStatus': 'Some chapters are not assigned yet. Assign them before you publish.',
  'aet.syllabus.dateNormalization.manualEntryContent': 'Add a due date before you publish.',
  'aet.deleteAssignmentTitle': 'Xóa bài tập?',
  'aet.deleteAssignmentTitleMultiple': 'Xóa bài tập?',
  'aet.deleteAssignmentWarning': 'Thao tác này không thể hủy và tất cả bài nộp liên quan cũng như dữ liệu học sinh sẽ không còn hiển thị.',
  'aet.deleteAssignmentKeepCTA': 'Giữ bài tập',
  'aet.deleteAssignmentDeleteCTA': 'Xóa',
  'aet.assignments.loadingAsset': 'Đang tải tài nguyên...',
  'aet.assignments.allCaughtUpDescription': 'Không có bài tập nào đến hạn trong tuần này.',
  'aet.assignments.progressTitle': 'Tiến bộ',
  'aet.assignments.performanceTitle': 'Sự tự tin',
  'aet.assignments.completionTitle': 'Hoàn thành',
  'aet.assignments.statusTitle': 'Trạng thái',
  'aet.assignments.addTooltip': 'Thêm bài tập',
  'aet.assignments.deleteTooltip': 'Xóa các bài tập đã chọn',
  'aet.assignments.selectToDeleteLabel': 'Chế độ chọn và xóa',
  'aet.assignments.bulkEditTooltip': 'Sửa nhiều bài tập cùng lúc',
  'aet.assignments.title': 'Bài tập',
  'aet.assignments.assignmentTitle': 'Bài tập',
  'aet.assignments.dueDate': 'Hạn nộp',
  'aet.tabular.searchPlaceholder.assignments': 'Tìm kiếm bài tập',
  'aet.tabular.searchPlaceholder.students': 'Tìm kiếm học sinh',
  'aet.tabular.searchPlaceholder.questions': 'Tìm kiếm câu hỏi',
  'aet.assignemnts.columnDueDateInfoTooltip': 'Một hoặc nhiều học sinh đã được gia hạn thời hạn nộp tất cả các bài tập',
  'aet.assignemnts.singleDueDateInfoTooltip': 'Một hoặc nhiều học sinh đã được gia hạn thời hạn nộp bài tập này',
  'aet.assignemnts.masterDueDateInfoTooltip': 'Một hoặc nhiều học sinh đã được gia hạn thời hạn nộp bài. Hãy tìm biểu tượng Thông tin để nhận biết các bài tập này.',
  'aet.home.loading': 'Đang tải...',
  'aet.home.errorFetchingAssignments': 'Lỗi khi tải bài tập',
  'aet.home.dueThisWeekTitle': 'Đến hạn trong tuần này',
  'aet.home.allCaughtUpTitle': 'Bạn đã hoàn thành tất cả!',
  'aet.home.allCaughtUpDescription': 'Không có bài tập nào đến hạn trong tuần này.',
  'aet.home.suggestedRemediationTitle': 'Đề xuất ôn tập bởi Study Prep',
  'aet.home.noSuggestedRemediationTitle': 'Không có tài liệu ôn tập được đề xuất',
  'aet.home.noSuggestedRemediationDescription': 'Hãy kiểm tra lại sau bài tập tiếp theo của bạn.',
  'aet.home.assignmentIncludesTitle': 'Bài tập bao gồm',
  'aet.home.sectionsLabel': 'Chương',
  'aet.home.questionsCount': '{count} câu hỏi',
  'aet.home.dueLabel': 'Hạn chót: {dueDate}',
  'aet.home.due': 'Hạn chót:',
  'aet.home.progressCompletedLabel': 'Đã hoàn thành',
  'aet.home.progressCompletedPastDueLabel': 'Đã hoàn thành quá hạn',
  'aet.home.progressInProgressLabel': 'Đang thực hiện',
  'aet.home.progressNotStartedLabel': 'Chưa bắt đầu',
  'aet.home.progressCountOfTotal': '{count}/{total}',
  'aet.home.NotAttemptedLabel': 'Chưa làm gì',
  'aet.home.questionsTotalLabel': 'Tổng số câu hỏi',
  'aet.home.progressCompletedOnTimeLabel': 'Hoàn thành đúng hạn',
  'aet.home.segmentGreatLabel': 'Tuyệt vời',
  'aet.home.segmentGettingThereLabel': 'Ok',
  'aet.home.segmentNeedsReviewLabel': 'Cần cải thiện',
  'aet.home.segmentOkayLabel': 'Ok',
  'aet.home.editAssignmentTooltip': 'Sửa bài tập',
  'aet.home.deleteAssignmentTooltip': 'Xóa bài tập',
  'aet.home.viewDetailsButton': 'Xem chi tiết',
  'aet.home.viewAsStudentButton': 'Xem với tư cách học sinh',
  'aet.home.welcomeButtonText': 'Bắt đầu →',
  'aet.review.emptyStateTitle': 'Không có nội dung nào để ôn tập',
  'aet.review.emptyStateDescription': 'Hãy kiểm tra lại sau bài tập tiếp theo của bạn.',
  'aet.dashboard.tabs.upNext': 'Tiếp theo',
  'aet.dashboard.tabs.welcome': 'Chào mừng',
  'aet.dashboard.tabs.assignments': 'Bài tập',
  'aet.dashboard.tabs.review': 'Xem xét',
  'aet.dashboard.tabs.studentRoster': 'Học sinh',
  'aet.dashboard.classSchedule': 'Lịch học:',
  'aet.syllabus.dueTimeLabel': 'Đúng hạn',
  'hero.accessEducatorGuides': 'Truy cập hướng dẫn dành cho nhà giáo dục',
  'aet.assignment.save': 'Lưu',
  'aet.assignment.saveAndAdd': 'Lưu và thêm bài tập khác',
  'aet.assignment.delete': 'Xóa',
  'aet.assignment.saveAndClose': 'Lưu và đóng',
  'aet.studentRoster.title': 'Học sinh',
  'aet.studentRoster.titlev1': 'Học sinh',
  'aet.studentRoster.dueDatesAdjustmentLabel': 'Hạn nộp',
  'aet.studentRoster.dueDateAdjustment.option.0': 'Tiêu chuẩn',
  'aet.studentRoster.dueDateAdjustment.option.2': '+2 ngày',
  'aet.studentRoster.dueDateAdjustment.option.3': '+3 ngày',
  'aet.studentRoster.dueDateAdjustment.option.5': '+5 ngày',
  'aet.studentRoster.dueDateAdjustment.option.week.1': '+1 tuần',
  'aet.studentRoster.dueDateAdjustment.option.week.2': '+2 tuần',
  'aet.studentRoster.dueDateAdjustment.option.lastDayOfClass': 'Ngày cuối cùng của lớp học',
  'aet.studentRoster.dueDateAdjustment.toast.partial.title.multiple': '{count} bài tập được cập nhật',
  'aet.studentRoster.dueDateAdjustment.toast.partial.message': 'Các bài tập quá hạn không thể được cập nhật tự động. Chỉnh sửa từng bài để đặt hạn nộp mới.',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.title': 'Không thể cập nhật hạn nộp',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.message': 'Tất cả bài tập đều đã quá hạn và không thể cập nhật tự động. Chỉnh sửa từng bài để đặt hạn nộp mới.',
  'aet.bulkEdit.bulkSplitInstruction': 'Chúng tôi sẽ phân bổ đều các bài tập của bạn.',
  'aet.bulkEdit.Description': 'Figma ipsum component variant main layer. Editor library device auto star reesizing pencil horizontal. Polygon main list figjam star layout object connection hand scale.',
  'aet.bulkEdit.firstAssignmentDue': 'Hạn nộp bài tập đầu tiên',
  'aet.bulkEdit.lastAssignmentDue': 'Hạn nộp bài tập cuối cùng',
  'aet.bulkEdit.assignmentsDueDays': 'Bạn muốn hạn nộp bài tập vào những ngày nào?',
  'aet.bulkEdit.addEditLaterText': 'Chúng tôi sử dụng AI để tạo bài tập. Bạn luôn có thể thêm và sửa bài tập sau.',
  'aet.bulkEdit.monday': 'Thứ Hai',
  'aet.bulkEdit.tuesday': 'Thứ Ba',
  'aet.bulkEdit.wednesday': 'Thứ Tư',
  'aet.bulkEdit.thursday': 'Thứ Năm',
  'aet.bulkEdit.friday': 'Thứ Sáu',
  'aet.bulkEdit.saturday': 'Thứ Bảy',
  'aet.bulkEdit.sunday': 'Chủ Nhật',
  'aet.toast.assignmentCreated.title': 'Bài tập đã được tạo!',
  'aet.toast.assignmentCreated.single': 'Tên bài tập đã được đặt tự động {assignmentTitle}',
  'aet.toast.assignmentCreated.multiple': '{count} bài tập đã được tạo',
  'aet.toast.assignmentUpdated.title': 'Đã cập nhật thành công.',
  'aet.toast.assignmentUpdated.single': '{assignmentTitle} đã được cập nhật',
  'aet.toast.assignmentUpdated.multiple': '{count} bài tập đã được cập nhật',
  'aet.toast.viewAssignment': 'Xem bài tập',
  'aet.toast.viewAssignments': 'Xem bài tập',
  'aet.welcome.title': 'Sách giáo khoa điện tử của Pearson hiện đã được liên kết với khóa học LMS của bạn',
  'aet.welcome.LMSAccounTitle': 'Tìm hiểu thông tin chi tiết',
  'aet.welcome.LMSAccounDescription': 'Xem chính xác các chủ đề lớp học của bạn đang gặp khó khăn.',
  'aet.welcome.createAssignmentsTitle': 'Tạo bài tập',
  'aet.welcome.createAssignmentsDescription': 'Giao bài tập theo chương theo cách thủ công hoặc bằng cách tải đề cương khóa học của bạn lên.',
  'aet.welcome.progressViewTitle': 'Theo dõi kết quả trong LMS của bạn',
  'aet.welcome.progressViewDescription': 'Chọn cài đặt đồng bộ điểm số trong khóa học LMS của bạn.',
  'aet.assignmentDetails.noAssignmentFound': 'Không tìm thấy bài tập',
  'aet.assignments.loadingErrorTitle': 'Hiện không thể tải bài tập',
  'aet.assignments.loadingErrorDescription': 'Vui lòng thử tải lại hoặc quay lại kiểm tra sau.',
  'aet.assignmentStudentDetails.noDataFound': 'Chưa có dữ liệu',
  'aet.assignmentStudentDetails.noData': 'No data',
  'aet.studentRoster.noStudentsRegisteredYet': 'Không có học sinh nào đăng ký',
  'aet.studentRoster.noStudentsRegisteredYetDescription': 'Học sinh sẽ tham gia lớp học khi họ mua sách giáo khoa điện tử.',
  'aet.home.editAssignmentTooltipDisabled': 'Không thể sửa: học sinh đang làm bài',
  'aet.home.deleteAssignmentTooltipDisabled': 'Không thể xóa: học sinh đang làm bài',
  'aet.home.StudentDetails.questions': 'Câu hỏi',
  'aet.home.StudentDetails.attempts': 'Lần thử',
  'aet.home.StudentDetails.comprehension': 'Sự tự tin',
  'hero.titleInfo.tooltip': 'Thông tin tựa sách',
  'aet.home.publishAssignments': 'Xuất bản tất cả các bài tập',
  'aet.dashboard.footer': 'Một số nội dung do AI tạo dựa trên tài liệu học của Pearson. Mặc dù Pearson có quy trình để xác thực kết quả, AI tạo sinh vẫn có thể tạo ra thông tin không chính xác về người, địa điểm hoặc sự kiện.',
  'aet.home.bulkEditTitle': 'Sửa nhiều bài tập cùng lúc',
  'aet.home.bulkEditSubtitle': 'Thực hiện thay đổi trên đề cương của bạn, sau đó tải lại lên đây. Bài tập và hạn nộp sẽ được cập nhật tương ứng.',
  'aet.home.createAssignmentTitle': 'Tạo bài tập',
  'aet.assignments.includedInAnotherAssignmentTooltip': 'Đã bao gồm trong một bài tập khác',
  'aet.assignments.someSectionsIncludedInAnotherAssignmentTooltip': 'Một số phần được bao gồm trong bài tập khác',
  'aet.welcome.welcome.Title': 'Chào mừng!',
  'aet.home.student.roaster.ProgressTitle': 'Hoàn thành toàn bộ',
  'aet.assignmentStudentDetails.startAssignmentDescription': 'Kiểm tra lại sau khi học sinh bắt đầu làm bài tập.',
  'aet.home.whatDueThisWeekTitle': 'Đây là bài tập cần nộp trong tuần này',
  'aet.assignments.edit.errorTitle': '{count} bài tập có lỗi',
  'aet.assignments.edit.errorSubTitle': 'Không thể xuất bản các bài tập có lỗi. Sửa hoặc xuất bản mà không bao gồm các bài tập này.',
  'aet.assignments.edit.publishAnyway': 'Vẫn xuất bản',
  'aet.assignments.edit.editAssignments': 'Sửa bài tập',
  'aet.assignments.edit.validationInfoToolTip': 'Sửa bài tập để loại bỏ lỗi',
  'aet.assignments.error.assignmentCreated.title': 'Tất cả bài tập đều có lỗi',
  'aet.assignments.error.assignmentCreated.description': 'Không thể xuất bản các bài tập có lỗi. Hãy sửa hoặc thử chọn đề cương khóa khác.',
  'aet.assignments.error.uploadSyllabus': 'Tải đề cương khóa học lên',
  'aet.assignments.error.editAssignments': 'Sửa bài tập',
  'aet.mondly.title': 'Ngôn ngữ',
  'aet.studentRoster.errorState.title': 'Danh sách học sinh không có sẵn',
  'aet.studentRoster.errorState.description': 'Chúng tôi không thể tải danh sách học sinh. Vui lòng thử tải lại hoặc quay lại kiểm tra sau.',
  'aet.assignments.sectionLabel': 'phần',
  'aet.assignments.questionsLabel': 'câu hỏi',
  'aet.assignments.assignmentsLabel': 'bài tập',
  'aet.assignments.performanceProgressBar': 'Thanh tiến độ hiệu suất',
  'aet.assignments.completionProgressBar': 'Thanh tiến độ hoàn thành',
  'aet.syllabus.deleteConfirmationSubtitleSingle': 'Bạn có chắc chắn muốn xóa bài tập này không?',
  'aet.syllabus.deleteConfirmationSubtitleBulk': 'Bạn có chắc chắn muốn xóa những bài tập này không?',
  'aet.home.nextAssignmentTitle': 'Bài tập tiếp theo',
  'aet.home.courseSettings': 'Cài đặt khóa học',
  'aet.home.pearsonETextbookResources': 'Tài nguyên sách giáo khoa điện tử của Pearson+',
  'aet.home.etextbookInformation': 'Thông tin về sách giáo khoa điện tử',
  'aet.multiple.deleteAssignmentKeepCTA': 'Giữ bài tập',
  'aet.syllabus.processingText.header': 'Chúng tôi đang sắp xếp các bài đọc được giao cho lớp học của bạn – việc này chỉ mất một chút thời gian.',
  'aet.syllabus.processingText.uploading': 'Đang tải tài liệu của bạn lên',
  'aet.syllabus.processingText.activating': 'Đang kích hoạt các thành phần AI',
  'aet.syllabus.processingText.extracting': 'Đang trích xuất bài tập đọc',
  'aet.syllabus.processingText.mapping': 'Đang đối chiếu với nội dung sách giáo khoa',
  'aet.syllabus.processingText.finishing': 'Đang hoàn tất',
  'aet.syllabus.uploadErrorMessage': 'Đảm bảo tệp PDF hoặc .docx của bạn có kích thước dưới 10MB và kết nối internet ổn định',
  'aet.syllabus.uploadNoAssignmentsMessage': 'No reading assignments found',
  'aet.syllabus.uploadNoAssignmentsDescription': 'We could not pull reading assignments from this file. You can add them manually.',
  'aet.syllabus.uploadFailedRetryCTA': 'Thử lại',
  'aet.syllabus.selectChapterWithQuestions': 'Chọn chương có chứa câu hỏi.',
  'preferenceSetting.subTitle': 'Các chế độ cài đặt này sẽ được áp dụng mặc định cho tất cả học sinh trong khóa học này.',
  'preferenceSetting.sections.isAIStudyEnabled.label': 'Tương tác với AI',
  'preferenceSetting.sections.isAIStudyEnabled.subLabel': 'Bật Công cụ học dựa trên AI và Tóm tắt do AI tạo trong kết quả tìm kiếm',
  'preferenceSetting.sections.isStudyPrepEnabled.subLabel': 'Hiện các tài nguyên Luyện thi liên quan đến sách này',
  'aet.syllabus.footer': 'Việc tạo bài tập được hỗ trợ bởi AI',
  'aet.dashboard.footerDialogDeatils': 'AI tạo sinh được sử dụng để tạo ra các câu hỏi bài tập dựa trên các tài liệu học tập của Pearson. Mặc dù Pearson có quy trình để xác thực kết quả, AI tạo sinh vẫn có thể tạo ra thông tin không chính xác về người, địa điểm hoặc sự kiện. AI cũng được sử dụng để nhóm nội dung thành các bài tập, dựa trên đề cương và/hoặc lịch trình do bạn cung cấp.',
  'aet.review.footer': 'Được tạo ra bằng AI',
  'aet.footerCard.dismiss': 'Đóng',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText1': 'Luyện thi là một công cụ hỗ trợ học tập bổ sung, cung cấp các video và bài tập thực hành được thiết kế riêng cho khóa học này.',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText2': 'Học sinh có gói truy cập không bao gồm Luyện thi có thể được yêu cầu đăng ký để tiếp tục sử dụng các tài nguyên của Luyện thi.',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText3': 'Học sinh đã mua gói Luyện thi sẽ không bị ảnh hưởng bởi chế độ cài đặt này.',
  'preferenceSetting.sections.isStudyPrepEnabled.helpLinkText': 'Tìm hiểu thêm về những lợi ích của Luyện thi',
  'aet.home.viewCourseId': 'Xem ID khóa học',
  'aet.home.copy': 'Sao chép',
  'aet.home.copied': 'Đã sao chép',
  'aet.home.courseLabel': 'ID khóa học:',
  'schoolInfoCard.addUniversity': 'Thêm trường học',
  'schoolInfoCard.title': 'Thông tin về trường học',
  'schoolInfoCard.titleV1': 'Hãy cho chúng tôi biết về khóa học của bạn',
  'schoolInfoCard.cta': 'Bắt đầu',
  'schoolInfoCard.pickInstitution': 'Chọn trường',
  'schoolInfoCard.addUniversityTitle': 'Thêm trường học của bạn',
  'schoolInfoCard.addUniversitySubtitle': 'Việc biết trường và khóa học giúp chúng tôi đề xuất những tài liệu học tập phù hợp nhất cho bạn.',
  'schoolInfoCard.searchPlaceholder': 'Tìm kiếm trường học của bạn...',
  'schoolInfoCard.skip': 'Bỏ qua bước này',
  'schoolInfoCard.nextStep': 'Bước tiếp theo',
  'schoolInfoCard.notInList': 'Trường của tôi không có trong danh sách',
  'schoolInfoCard.noResults': 'Không tìm thấy trường học phù hợp với tìm kiếm của bạn',
  'schoolInfoCard.noResultsHeading': 'Không tìm thấy trường của bạn?',
  'schoolInfoCard.noResultsInstruction': 'Vui lòng nhập tên đầy đủ bên dưới',
  'schoolInfoCard.noResultsInputPlaceholder': 'Tên trường',
  'schoolInfoCard.addInstitutionLabel': 'Thêm trường này',
  'aet.assignments.assignmentTitlePlaceholder': 'Nhập tựa đề',
  'aet.assignments.titleValidation.titleRequired': 'Tựa đề bài tập là bắt buộc.',
  'aet.assignments.titleValidation.titleTooLong': 'Tựa đề bài tập không được vượt quá {0} ký tự.',
  'aet.assignments.titleValidation.titleInvalidChar': 'Tựa đề bài tập chứa các ký tự không được hỗ trợ.',
  'aet.assignments.titleValidation.titleDuplicate': 'Tựa đề bài tập đã tồn tại',
  'aet.syllabus.timeZoneLabel': 'Múi giờ',
  'aet.review.reviewReadingFromAssignments': 'Xem bài đọc trong bài tập',
  'aet.assignments.chaptersLabel': 'chương',
  'menu.myAccount.subTitle': 'Cơ sở đào tạo của bạn ở đây',
  'menu.myAccount.subTitleNotAvailable': 'Bạn có thể thêm thông tin về cơ sở đào tạo vào đây sau này.',
  'schoolInfoCard.toastMessage': 'Đã lưu trường đại học',
  'aet.review.threeDotMenu.askAI': 'Hỏi AI',
  'aet.home.suggestedRemediationSubtitle': 'Xem các video liên quan và luyện tập để nắm vững các chủ đề của khóa học.',
  'aet.home.laggedQuestionLabel': 'Câu hỏi đã gắn cờ',
  'aet.home.correctAnswer': 'Câu trả lời đúng',
  'aet.home.incorrectAnswer': 'Câu trả lời sai phổ biến nhất',
  'aet.home.behaviourTrendsLabel': 'Thông tin chi tiết về câu hỏi',
  'aet.home.strugglingStudentsLabel': 'Học sinh gặp khó khăn',
  'aet.home.patternsInStudensAiLabel': 'Xu hướng sử dụng AI của học sinh',
  'aet.home.questionLabel': 'Câu hỏi',
  'aet.home.studentAskingSimilarQuestions': 'Học sinh đặt các câu hỏi tương tự',
  'aet.home.assignmentDifficultQuestions': 'Câu hỏi khó',
  'aet.home.behaviorTrends': 'Thông tin chi tiết về câu hỏi',
  'aet.home.behaviors': 'Các chỉ số hiệu suất',
  'aet.home.mostDifficultTopics': 'Những câu hỏi khó nhất',
  'aet.home.commentsFromStudentLabel': 'Nhận xét của học sinh',
  'aet.home.disregard': 'Bỏ qua',
  'aet.home.reportAsInaccurate': 'Báo cáo là không chính xác',
  'aet.home.Flagged': 'Đã gắn cờ',
  'aet.home.reportQuestionTitle': 'Báo cáo câu hỏi',
  'aet.home.reportQuestionLabel': 'Câu hỏi này có vấn đề gì?',
  'aet.home.showComments': 'Hiện bình luận',
  'aet.home.studentReports': 'báo cáo của học sinh',
  'aet.home.placeholderText': 'Vui lòng giải thích...',
  'aet.home.reportQuestion.notRelevant': 'Không liên quan',
  'aet.home.reportQuestion.notCorrect': 'Không chính xác',
  'aet.home.reportQuestion.unsafe': 'Không an toàn/có hại',
  'aet.home.reportQuestion.somethingElse': 'Một điều khác',
  'aet.home.StudentDetails.assistedByAI': 'Được hỗ trợ bởi AI',
  'aet.home.strugglingStudents.emptyStateTitle': 'Hiện không có học sinh nào gặp khó khăn',
  'aet.home.strugglingStudents.emptyStateDescription': 'Kiểm tra lại sau.',
  'aet.home.overallStatus.excelling': 'Xuất sắc',
  'aet.home.overallStatus.fallingBehind': 'Đang bị tụt lại',
  'aet.home.overallStatus.keepingUp': 'Theo kịp tiến độ',
  'aet.home.showOnlyDifficultQuestionsLabel': 'Chỉ hiện "Câu hỏi khó"',
  'aet.home.showOnlyStrugglingStudentsLabel': 'Chỉ hiện “Học sinh gặp khó khăn”',
  'aet.home.viewQuestionInAssignment': 'Xem câu hỏi trong bài tập',
  'aet.home.insightRisk.incorrectFirstAttempts': 'Những lần thử đầu tiên không chính xác',
  'aet.home.insightRisk.multipleIncorrectAttempts': 'Nhiều lần thử không chính xác',
  'aet.home.insightRisk.lowConfidence': 'Độ tin cậy thấp',
  'aet.home.insightRisk.mediumConfidence': 'Độ tin cậy trung bình',
  'aet.home.insightRisk.lowEngagement': 'Mức độ tương tác thấp',
  'aet.home.insightRisk.countOfStudents': '{count}/{total} học sinh',
  'aet.home.insightRisk.na': 'Không áp dụng',
  'aet.home.strugglingStudentsHereLabel': 'Học sinh gặp khó khăn ở phần này',
  'aet.home.insightRisk.didNotAttempt': 'Chưa thử sức',
  'aet.home.insightRisk.attempted': 'Attempted',
  'aet.courseHeader.assignableEText': 'Assignable eText'
};

export default vi;
